import { render, staticRenderFns } from "./photo-material-loose.vue?vue&type=template&id=477e80a0&scoped=true&"
import script from "./photo-material-loose.vue?vue&type=script&lang=js&"
export * from "./photo-material-loose.vue?vue&type=script&lang=js&"
import style0 from "./photo-material-loose.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./photo-material-loose.vue?vue&type=style&index=1&id=477e80a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477e80a0",
  null
  
)

export default component.exports